import { render, staticRenderFns } from "./PhyAttendModal.vue?vue&type=template&id=644d6d2d&scoped=true"
import script from "./PhyAttendModal.vue?vue&type=script&lang=js"
export * from "./PhyAttendModal.vue?vue&type=script&lang=js"
import style0 from "./PhyAttendModal.vue?vue&type=style&index=0&id=644d6d2d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d6d2d",
  null
  
)

export default component.exports